// This file is autogenerated from /frontend/sail-next/packages/docs/src/markdoc/demo/switch/Primary.story.tsx with go/sail-next-tailor-docs-publisher 

import * as React from 'react';
import { Switch } from '@sail/ui';
export const Primary = () => <Switch disabled={false} label="This is a Switch." onChange={e => {
  // eslint-disable-next-line no-console
  console.log(e.target.checked);
}} />;